module.exports = __webpack_public_path__ + "img/forgot_password_lock.b9fdba2a.svg";